import Vue from 'vue';

function initialState() {
    return {
        errors: false,
        fuelTypeHandle: '',
        modelHandle: '',
        dropdownFuelType: null,
        dropdownFuelTypeValue: null,
        dropdownModel: null,
        dropdownModelValue: null,
        dropdownModelValueSplit: null,

        fuelConsumption: null,
        isFuelConsumptionClicked: false,

        isCalculated: false,
        fuelValues: null,
        electricValues: null,
        fuelConsumptionPer100: null,
        electricConsumptionPer100: null,
        fuelConsumptionPer15: null,
        electricConsumptionPer15: null,
        showNoSavings: false,
        isCalculatorReady: false,

        monthlySaving: null,
        rechargeCost: null,
        dropdownId: null,
    };
}

Vue.component('electric-calculator-component', {
    data: initialState,

    mounted() {
        this.handleInputTakeOnlyNumbers();
        document.addEventListener(
            'click',
            this.handleClickOutsideConsumptionInput,
        );

        this.handleLitresLabelMargin(3);
    },

    beforeUnmount() {
        document.removeEventListener(
            'click',
            this.handleClickOutsideConsumptionInput,
        );
    },

    watch: {
        fuelConsumption(value) {
            if (!value) return;
            this.handleLitresLabelMargin(value.length);
            if (!this.dropdownFuelTypeValue || !this.dropdownModelValue) {
                return;
            }
            this.calculateSavings();
        },

        dropdownFuelType(value) {
            const areValuesChosen =
                value &&
                Boolean(this.fuelConsumption.length) &&
                this.dropdownModelValue;

            if (!areValuesChosen) return;
            this.calculateSavings();
        },

        dropdownModelValue(value) {
            const areValuesChosen =
                value &&
                Boolean(this.fuelConsumption.length) &&
                this.dropdownFuelType;
            if (!areValuesChosen) return;
            this.calculateSavings();
        },

        isFuelConsumptionClicked(value) {
            this.handleResetInputLength(value);
        },
    },

    methods: {
        toggleDropdown(event) {
            let element = event.currentTarget;
            if (this.dropdownId == element.id) this.dropdownId = null;
            else this.dropdownId = element.id;

            while ((element = element.parentElement)) {
                if (element.classList.contains('dropdown')) {
                    element.classList.toggle('dropdown--active');
                }
            }
        },

        setFuelType(event) {
            this.dropdownFuelType = event.currentTarget.dataset.text;
            this.dropdownFuelTypeValue = event.currentTarget.dataset.value;
            this.toggleDropdown(event);
        },

        setModel(event) {
            this.dropdownModel = event.currentTarget.dataset.text;
            this.dropdownModelValue = event.currentTarget.dataset.value;
            this.dropdownModelValueSplit =
                event.currentTarget.dataset.value.split('-')[0];
            this.toggleDropdown(event);
        },

        handleInputTakeOnlyNumbers() {
            const inputField = document.querySelector('#fuelConsumption');
            inputField.addEventListener('input', (event) => {
                const onlyNumbers = event.target.value
                    .replace(/[^0-9.]/g, '')
                    .replace(/(\..*)\./g, '$1');
                event.target.value = onlyNumbers;
                this.fuelConsumption = onlyNumbers;
            });
        },

        handleClickOutsideConsumptionInput(event) {
            const inputField = document.querySelector('#fuelConsumption');
            if (!inputField) return;

            if (!inputField.contains(event.target)) {
                this.isFuelConsumptionClicked = false;
                return;
            }

            this.isFuelConsumptionClicked = true;
        },

        handleLitresLabelMargin(valueLength) {
            const inputFieldLabel = document.querySelector(
                '#fuelConsumptionLiters',
            );
            if (!inputFieldLabel) return;
            inputFieldLabel.style.marginLeft = valueLength + 'ch';
        },

        handleResetInputLength(clickValue) {
            const inputField = document.querySelector('#fuelConsumption');
            if (!inputField || clickValue) return;
            inputField.style.width = '100%';
        },

        getAverageFuelPrice(fuelType) {
            switch (fuelType) {
                case 'sans-plomb-98-e5':
                    return 1.927;
                case 'sans-plomb-95-e5':
                    return 1.861;
                case 'sans-plomb-95-e10':
                    return 1.843;
                case 'bio-ethanol-e85':
                    return 1.135;
                case 'gazole-b7':
                    return 1.685;
                default:
                    return null;
            }
        },

        getElectricValues(modelType) {
            switch (modelType) {
                case 'marvel-r-2wd':
                    return {
                        consumption: 19.4,
                        battery: 70,
                        unit: 'kWh',
                        averagePrice: 0.2062,
                        autonomy: 402,
                        co2: 0,
                    };
                case 'marvel-r-4wd':
                    return {
                        consumption: 20.9,
                        battery: 70,
                        unit: 'kWh',
                        averagePrice: 0.2062,
                        autonomy: 370,
                        co2: 0,
                    };
                case 'mg5-luxury-50':
                    return {
                        consumption: 17.9,
                        battery: 50.3,
                        unit: 'kWh',
                        averagePrice: 0.2062,
                        autonomy: 310,
                        co2: 0,
                    };
                case 'mg5-luxury-61':
                    return {
                        consumption: 17.5,
                        battery: 61.1,
                        unit: 'kWh',
                        averagePrice: 0.2062,
                        autonomy: 380,
                        co2: 0,
                    };
                case 'mg5-comfort-50':
                    return {
                        consumption: 17.9,
                        battery: 50.3,
                        unit: 'kWh',
                        averagePrice: 0.2062,
                        autonomy: 320,
                        co2: 0,
                    };
                case 'mg5-comfort-61':
                    return {
                        consumption: 17.5,
                        battery: 61.1,
                        unit: 'kWh',
                        averagePrice: 0.2062,
                        autonomy: 400,
                        co2: 0,
                    };
                case 'mg4-standard':
                    return {
                        consumption: 17,
                        battery: 51,
                        unit: 'kWh',
                        averagePrice: 0.2062,
                        autonomy: 350,
                        co2: 0,
                    };
                case 'mg4-comfort':
                    return {
                        consumption: 16,
                        battery: 64,
                        unit: 'kWh',
                        averagePrice: 0.2062,
                        autonomy: 450,
                        co2: 0,
                    };
                case 'mg4-luxury':
                    return {
                        consumption: 16.6,
                        battery: 64,
                        unit: 'kWh',
                        averagePrice: 0.2062,
                        autonomy: 435,
                        co2: 0,
                    };
                case 'zs-ev-51':
                case 'zs-ev-comfort-51':
                    return {
                        consumption: 17.3,
                        battery: 51,
                        unit: 'kWh',
                        averagePrice: 0.2062,
                        autonomy: 320,
                        co2: 0,
                    };
                case 'zs-ev-luxury-70':
                case 'zs-ev-comfort-70':
                    return {
                        consumption: 17.8,
                        battery: 69.9,
                        unit: 'kWh',
                        averagePrice: 0.2062,
                        autonomy: 440,
                        co2: 0,
                    };
                default:
                    return {};
            }
        },

        getConsumptionPer100(e) {
            return (e.averagePrice * e.consumption).toFixed(2);
        },

        resetValues() {
            const resetData = { ...initialState() };
            Object.assign(this.$data, resetData);
            this.handleLitresLabelMargin(3);
        },

        showResults() {
            this.isCalculatorReady = true;

            this.calculateSavings();
        },

        calculateSavings() {
            if (!this.isCalculatorReady) return;
            if (
                !this.fuelConsumption ||
                !this.dropdownFuelTypeValue ||
                !this.dropdownModelValue
            ) {
                this.errors = true;
                return;
            }

            this.fuelValues = {
                averagePrice: this.getAverageFuelPrice(
                    this.dropdownFuelTypeValue,
                ),
                consumption: Number(this.fuelConsumption),
            };
            this.electricValues = this.getElectricValues(
                this.dropdownModelValue,
            );
            this.fuelConsumptionPer100 = this.getConsumptionPer100(
                this.fuelValues,
            );
            this.electricConsumptionPer100 = this.getConsumptionPer100(
                this.electricValues,
            );

            this.fuelConsumptionPer15 = Math.round(
                this.fuelConsumptionPer100 * 150,
            );
            this.electricConsumptionPer15 = Math.round(
                this.electricConsumptionPer100 * 150,
            );

            this.monthlySaving = Math.abs(
                (this.electricConsumptionPer15 - this.fuelConsumptionPer15) /
                    12,
            ).toFixed(2);
            this.rechargeCost = (
                this.electricValues.battery * this.electricValues.averagePrice
            ).toFixed(2);

            if (
                Number(this.fuelConsumptionPer100) <
                Number(this.electricConsumptionPer100)
            )
                this.showNoSavings = true;
            else this.showNoSavings = false;

            this.errors = false;
            this.isCalculated = true;
        },
    },
});
